<template>
  <Page current-link="books">
    <Banner></Banner>
    <div style="height: 54px;"></div>
    <div class="watermarkIndex"></div>
    <div class="col-center">
      <div class="title col">
        <img src="/books/title.png"/>
      </div>


      <div class="row-center-reactive desktop" v-if="books.specialtyBook">
        <div>
          <nuxt-link to="/books/specialty-hardcover">
            <img :src="books.specialtyBook?.image?.src" style="width: 303px"/>
          </nuxt-link>
        </div>
        <div style="width: 303px">
          <div style="width: 262px; text-align: center">
            <TitleLg>Specialty hardcover</TitleLg>
            <SpecialtyHardcoverDescription/>
            <Price v-if="books.specialtyBook?.price"
            >${{ books.specialtyBook?.price }} AUD
            </Price
            >

            <a class="button" @click="addToCart(books.specialtyBook?.gid)">ADD TO CART</a>
            <div style="height: 10px"></div>
            <NuxtLink class="button" to="/books/specialty-hardcover" style="margin-top: 0px"
            >MORE INFO
            </NuxtLink
            >
          </div>
        </div>
      </div>

      <BookItem
          class="mobile"
          v-if="books.specialtyBook"
          link="/books/specialty-hardcover"
          title="Specialty hardcover"
          :price="'$' + (books.specialtyBook?.price ?? '') + ' AUD'"
          :image="books.specialtyBook?.image?.src ?? ''"
          :gid="books.specialtyBook?.gid ?? ''"
      >
        <SpecialtyHardcoverDescription/>
      </BookItem>

      <div class="row-center-reactive" style="margin-top: 75px">
        <BookItem
            v-if="books.hardcoverBook"
            link="/books/standard-hardcover"
            title="Standard hardcover"
            image-class="book-shadow"
            :price="'$' + (books.hardcoverBook?.price ?? '') + ' AUD'"
            :image="books.hardcoverBook?.image?.src ?? ''"
            :gid="books.hardcoverBook?.gid ?? ''"
        ></BookItem>
        <div style="height: 80px;"></div>
        <BookItem
            v-if="books.paperbackBook"
            link="/books/paperback"
            title="Paperback"
            image-class="book-shadow"
            :price="'$' + (books.paperbackBook?.price ?? '') + ' AUD'"
            :image="books.paperbackBook?.image?.src ?? ''"
            :gid="books.paperbackBook?.gid ?? ''"
        ></BookItem>
      </div>

      <div class="slider">
        <carousel
            :items-to-show="1"
            class="carousel"
            :wrap-around="true"
            :autoplay="3000"
        >
          <slide key="peek1">
            <a href="/books/page1.pdf" target="_blank">
              <img src="/books/peek1.jpg"/>
            </a>
          </slide>
          <slide key="peek2">
            <a href="/books/page2.pdf" target="_blank">
              <img src="/books/peek2.jpg"/>
            </a>
          </slide>
          <slide key="peek3">
            <a href="/books/page3.pdf" target="_blank">
              <img src="/books/peek3.jpg"/>
            </a>
          </slide>
          <slide key="peek4">
            <a href="/books/page4.pdf" target="_blank">
              <img src="/books/peek4.jpg"/>
            </a>
          </slide>

          <template #addons>
            <navigation/>
            <pagination/>
          </template>
        </carousel>
      </div>
      <!-- <div class="row-center">
          <BookItem
            link="#"
            title="eBook"
            price="$49.99 AUD"
            image="/books/cover-hardback.png"
          ></BookItem>
        </div> -->
    </div>
  </Page>
</template>

<script setup lang="ts">
// import SimpleLightbox from "simplelightbox/dist/simple-lightbox.esm";
import "vue3-carousel/dist/carousel.css";
import {Carousel, Navigation, Pagination, Slide} from "vue3-carousel";

import {useBooksStore} from "~/store/books";
import {useCartStore} from "~/store/cart";
import SpecialtyHardcoverDescription from "~/pages/books/SpecialtyHardcoverDescription.vue";

const cart = useCartStore();

async function addToCart(id?: string) {
  if (!id) return;
  await cart.addItem(id);
  navigateTo("/cart");
}


const books = useBooksStore();
books.fetchBooks();
</script>
<style>

.title {
  @media (max-width: 600px) {
    margin-bottom: 20px;
  }
  @media (min-width: 601px) {
    margin-bottom: 70px;
  }
}

.carousel img {
  max-height: 140px;

  object-fit: contain;
}


.watermarkIndex {
  position: absolute;
  background-image: url('/blue-watermark.png');
  width: 1016px;
  left: 0;
  height: 681px;
  top: 524px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  z-index: -3;
}

.book-shadow {
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
}

img {
  max-width: 50vw;
}

.slider {
  margin: 100px auto 10px auto;
  @media (max-width: 600px) {
    width: 80vw;
    padding: 0;
  }
  @media (min-width: 601px) {
    width: 400px;
  }
}
</style>
